if (window.innerWidth > 1025 && window.innerWidth < 1920) {
    var windowWidth = window.innerWidth;
    var leftMarginSize = (windowWidth - 1216) / 2;
    var swiperRev = document.querySelector('.wls-reviews__items');
    swiperRev.style.marginLeft = leftMarginSize + 'px';

}

const swiperReviews = new Swiper('.wls-reviews__items', {
    loop: true,
    slidesPerView: "auto",
    spaceBetween: 20,

    breakpoints: {
        768: {
            spaceBetween: 32,
            slidesPerView: "auto",
        },
        1920: {
            centeredSlides: true,
        }
    },

    pagination: {
        el: '.wls-swiper-reviews__pagination',
        clickable: true,
    },

    navigation: {
        nextEl: '.slider-reviews-next',
        prevEl: '.slider-reviews-prev',
    },
});